import request from 'lib/request';

export interface Response {
  code: number;
  msg: string;
  data:null;
}

export async function removeProjecWhitelist(id: number, address: string) {
  const res = await request<Response>('/project/remove_whitelist', {
    method: 'POST',
    data: {
      id,
      address,
    },
  });
  return res;
}
